import { Select } from '@warp-ds/react/components/select';
import type { FlexibilityOption } from '@/interfaces';

export interface Props {
    options: FlexibilityOption[];
    selected: string | number;
    onChange: (value: string) => void;
}

export const FlexibleDateHandler = ({ options, selected, onChange }: Props) => (
    <Select
        label="Fleksibilitet"
        value={selected.toString()}
        onChange={(event) => onChange(event.target.value)}
        data-testid="flexible-date">
        {options.map((item) => (
            <option key={`flexible-date-${item.value}`} value={item.value}>
                {item.text}
            </option>
        ))}
    </Select>
);
